import { HelpCircle, Mail, X } from "react-feather";
import { Popover } from "@headlessui/react";
import cx from "classnames";
import Image from "next/image";

const StepLayout = ({ image, question, children, progress, className }) => {
  return (
    <div className={cx("bg-brand-turquoise-100 rounded-br-[5rem]", className)}>
      {progress && (
        <div className="overflow-hidden rounded-full p-0.5">
          <div
            className="h-1 rounded-full bg-brand-blue-600"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      )}
      <div className="relative pt-[4.5rem] pb-10 px-6 bg-brand-turquoise-500 rounded-b-[5rem]">
        <div className="absolute top-3 right-7">
          <Popover className="relative">
            <Popover.Button>
              <HelpCircle className="h-6 w-6" />
            </Popover.Button>

            <Popover.Overlay className="fixed z-20 bg-white inset-0" />

            <Popover.Panel className="fixed inset-x-0 h-[calc(100%-70px)] md:h-[calc(100%-94px)] z-20 pt-[70px] px-8 md:pt-[94px] bg-brand-turquoise-100 rounded-br-[5rem] top-0">
              <div className="flex justify-end w-full mt-3">
                <Popover.Button className="flex items-center">
                  Schließen
                  <X className="h-6 w-6 ml-2" />
                </Popover.Button>
              </div>
              <div className="h-full flex items-center justify-center">
                <div>
                  <h6 className="mb-4">Sie benötigen Unterstützung?</h6>
                  <p className="mb-8 text-body">Wir beraten Sie gern.</p>

                  <div>
                    <a
                      href="mailto:anfrage@planmaschine.de"
                      className="mb-8 flex items-center"
                    >
                      <span className="mr-4 rounded-full border p-2 border-brand-blue-600">
                        <Mail className="h-5 w-5" />
                      </span>
                      <span>anfrage@planmaschine.de</span>
                    </a>
                  </div>
                </div>
              </div>
            </Popover.Panel>
          </Popover>
        </div>
        <div className="mx-auto w-28">
          <Image 
            src={image.src} 
            alt="Logo" 
            width={112} // Adjusted width for responsive rendering
            height={112} // Adjusted height for responsive rendering
          />
        </div>
        <h5 className="mx-auto mt-10 text-center">{question}</h5>
      </div>

      <div className="mx-auto flex max-w-lg flex-col px-4 py-12">
        {children}
      </div>
    </div>
  );
};

export default StepLayout;
